import { Project } from "@/api";
import { FilterFieldData } from "@/hooks/useFilterSort";

export const projectsFilterData: FilterFieldData<Project> = {
  archived_at: {
    displayName: "Archived At",
    type: "string",
  },
};
